define('viewmodels/RiskRating/RiskRatingDashboard',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {

        var RaTableObj = false;
        var NotificationTblObj = false;
        var CompletedTblObj = false;

        var RRDashboardVM = {
            activate: activate,
            attached: attached,
            detached: detached,
            logger: logger,
            appsecurity: appsecurity,

            currentPageNumber: ko.observable(),
            SelectedStatus: ko.observable(),

            // Roles
            RoleValue: ko.observable(),
            ResponseMoveArray: ko.observable(),

            //New Assignments
            AssignedCount: ko.observable(0),
            Assignmentlist: ko.observableArray([]),
            NewAssignmentClick: NewAssignmentClick,
            MoveSurveyToWorkInProgress: MoveSurveyToWorkInProgress,
            ProductMoveArray: ko.observableArray(),

            // Work In Progress
            WorkInProgressCount: ko.observable(0),
            WorkInProgresslist: ko.observableArray(),
            WIPClick: WIPClick,

            //Completed 
            CompletedCount: ko.observable(0),
            CompletedList: ko.observableArray(),

            // Notifications 
            NotificationsCount: ko.observable(0),
            Notificationlist: ko.observableArray([])
        };

        return RRDashboardVM;

        function attached() {
            try {
                GetRRDashboard();
                RaTableObj = $('#tblNewAssignmentRR').DataTable({ "bVisible": false });
                $('#tblNewAssignmentRR').on('page.dt', function (event) {
                    RRDashboardVM.currentPageNumber(RaTableObj.page());
                });

                WIPTableObj = $('#tblWorkInProgressRR').DataTable({ "bVisible": false });
                $('#tblWorkInProgressRR').on('page.dt', function (event) {
                    RRDashboardVM.currentPageNumber(WIPTableObj.page());
                });


                CompletedTblObj = $('#tblCompletedRR').DataTable({ "bVisible": false });
                $('#tblCompletedRR').on('page.dt', function (event) {
                    RRDashboardVM.currentPageNumber(CompletedTblObj.page());
                });

                NotificationTblObj = $('#tblNotificationRR').DataTable();

                if (RRDashboardVM.appsecurity !== undefined && RRDashboardVM.appsecurity.userInfo() !== undefined && RRDashboardVM.appsecurity.userInfo().PrimaryRoleId() !== undefined) {
                    RRDashboardVM.RoleValue(RRDashboardVM.appsecurity.userInfo().PrimaryRoleId());
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function activate() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#region GetRRDashboard

        function GetRRDashboard() {
            try {
                $('#divTables').hide();
                $('#loadingImgforDashboard').show();
                GetAllNewAssignments().then(function () {
                    GetAllWIPAssignments().then(function () {
                        GetAllCompletedAssignments().then(function () {
                            $('#loadingImgforDashboard').hide();
                            $('#dashboardStatuses').show();
                            $('#divTables').show();
                        });
                    });
                });

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetRRDashboard() in RiskRatingDashboard.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region NewAssignments

        function GetAllNewAssignments() {
            try {
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetAssignmentsList",
                    data: { 'WorkingFlag': 0},
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllNewAssignment() in RiskRatingDashboard.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, Success) {
                try {
                    if (jsonResult !== null) {
                        RRDashboardVM.Assignmentlist([]);
                        RRDashboardVM.appsecurity.WriteAccess('true');
                        RRDashboardVM.AssignedCount(jsonResult.length);

                        RaTableObj.clear().destroy();
                        $('#tblNewAssignmentRR tbody tr').remove();

                        var mappedList = $.map(jsonResult, function (result) {
                            return new RRSurveyDashboardModel(result);
                        });

                        RRDashboardVM.Assignmentlist(mappedList);

                        RaTableObj = undefined;
                        RaTableObj = $('#tblNewAssignmentRR').DataTable({
                            "aLengthMenu": [5, 10, 25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false,
                                "bSortable": false
                            }, {
                                "aTargets": [2],
                                "bSearchable": false,
                                "bSortable": false
                            }]
                        });
                        RaTableObj.draw();
                        RRDashboardVM.currentPageNumber(RaTableObj.page());
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the New Assignments queue.', 'Error', system.getModuleId(RRDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllNewAssignment() in RiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllNewAssignment() method in RiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllNewAssignment() method in RiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        function NewAssignmentClick(data, event) {
            try {
                app.showMessage('Do you want to move selected survey to your Work In Progress list?', 'Move Survey', [' Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-exchange text-default' })
                    .then(function (option) {
                        if (option === ' Confirm') {
                            MoveSurveyToWorkInProgress(data.SurveyType(), data.SurveyId());
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NewAssignmentClick() in RiskRatingDashboard.js';
                logger.logMessage(msg);
            }
        }
        
        function MoveSurveyToWorkInProgress(SurveyType, SurveyId) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/RiskRatingDashboard/MoveSurveyToWorkInProgress?SurveyType=" + SurveyType + "&SurveyId=" + SurveyId,
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajax call in MoveSurveyToWorkInProgress() in RiskRatingDashboard.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult === 1) {
                        logger.logSuccess('Survey has been moved to the Working queue successfully.', 'Success', system.getModuleId(RRDashboardVM), true);
                        GetAllNewAssignments();
                        GetAllWIPAssignments();
                    }
                    else if (jsonResult === 0) {
                        logger.logWarning('The Survey that you are trying to move has already been picked by another user.', 'Success', system.getModuleId(RRDashboardVM), true);
                        GetAllNewAssignments();
                    }
                    else {
                        logger.logError('An error occurred while moving the Assignment to Work in Progress queue.', 'Error', system.getModuleId(RRDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + 'Source: ajaxSuccess in MoveSurveyToWorkInProgress() in ProdcutRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    router.navigate("configuration", true);

                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in ProdcutRiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in ProdcutRiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region WorkInProgress

        function GetAllWIPAssignments() {
            try {
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetAssignmentsList",
                    data: { 'WorkingFlag': 1 },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllWIPAssignments() in RiskRatingDashboard.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult !== null) {
                        RRDashboardVM.WorkInProgresslist([]);
                        RRDashboardVM.appsecurity.WriteAccess('true');
                        RRDashboardVM.WorkInProgressCount(jsonResult.length);

                        WIPTableObj.clear().destroy();
                        $('#tblWorkInProgressRR tbody tr').remove();

                        var mappedList = $.map(jsonResult, function (result) {
                            return new RRSurveyDashboardModel(result);
                        });
                        RRDashboardVM.WorkInProgresslist(mappedList);

                        WIPTableObj = undefined;
                        WIPTableObj = $('#tblWorkInProgressRR').DataTable({
                            "aLengthMenu": [5, 10, 25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false,
                                "bSortable": false
                            }, {
                                "aTargets": [2],
                                "bSearchable": false,
                                "bSortable": false
                            }]
                        });
                        WIPTableObj.draw();
                        RRDashboardVM.currentPageNumber(WIPTableObj.page());
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the Work In Progress queue.', 'Error', system.getModuleId(RRDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllWIPAssignments() in RiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllWIPAssignments() method in RiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllWIPAssignments() method in RiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        function WIPClick(data, event) {
            try {
                var ObjectItem = ko.toJS(data);
                var SelectedRoleName = "";
                
                if (RRDashboardVM.appsecurity !== undefined && RRDashboardVM.appsecurity.userInfo() !== undefined && RRDashboardVM.appsecurity.userInfo().PrimaryRoleId() !== undefined) {
                    RRDashboardVM.RoleValue(RRDashboardVM.appsecurity.userInfo().PrimaryRoleId());
                    SelectedRoleName = RRDashboardVM.appsecurity.userInfo().PrimaryRoleName();
                }
                RRDashboardVM.SelectedStatus(data.ProcessPoint());
                RRDashboardVM.ResponseMoveArray(new RRSurveyDashboardModel(ObjectItem));
                router.navigate("#RiskRating/RiskRatingResponsePage", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | WIPClick() in RiskRatingDashboard.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region CompletedAssignments

        function GetAllCompletedAssignments() {
            try {
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetAssignmentsList",
                    type: "GET",
                    data: { 'WorkingFlag': 2 },
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllCompletedAssignments() in RiskRatingDashboard.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, Success) {
                try {
                    if (jsonResult !== null) {
                        RRDashboardVM.CompletedList([]);
                        RRDashboardVM.appsecurity.WriteAccess('true');
                        RRDashboardVM.CompletedCount(jsonResult.length);

                        CompletedTblObj.clear().destroy();
                        $('#tblCompletedRR tbody tr').remove();

                        var mappedList = $.map(jsonResult, function (result) {
                            return new RRSurveyDashboardModel(result);
                        });

                        RRDashboardVM.CompletedList(mappedList);

                        CompletedTblObj = undefined;
                        CompletedTblObj = $('#tblCompletedRR').DataTable({
                            "aLengthMenu": [5, 10, 25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false,
                                "bSortable": false
                            }, {
                                "aTargets": [2],
                                "bSearchable": false,
                                "bSortable": false
                            }]
                        });
                        CompletedTblObj.draw();
                        RRDashboardVM.currentPageNumber(CompletedTblObj.page());
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the Completed queue.', 'Error', system.getModuleId(RRDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllCompletedAssignments() in RiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllCompletedAssignments() method in RiskRatingDashboard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllCompletedAssignments() method in RiskRatingDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region Model Definitions

        function RRSurveyDashboardModel(item) {
            try {
                var self = this;
                self.SurveyType = ko.observable(item.SurveyType);
                self.SurveyId = ko.observable(item.SurveyId);
                self.SurveyName = ko.observable(item.SurveyName);
                self.MRRAId = ko.observable(item.MRRAId);
                self.MRRAName = ko.observable(item.MRRAName);
                self.SurveyTableId = ko.observable(item.SurveyTableId);
                self.SurveyTableKey = ko.observable(item.SurveyTableKey);
                self.ProcessPoint = ko.observable(item.ProcessPoint);
                self.AssignedDate = ko.observable(item.AssignedDate);
                self.WPPLevel = ko.observable(item.WPPLevel);
                self.AssignedUserName = ko.observable(item.AssignedUserName);
                self.WPPUId = ko.observable(item.WPPUId);
                self.IsAvailableFlag = ko.observable(item.IsAvailableFlag);
                self.PushedBackSurveyFlag = ko.observable(item.PushedBackSurveyFlag);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: RRSurveyDashboardModel() in ProductRiskRatingDashBoard.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

    });
